<template>
  <div v-if="drivingStyleData">
    <div>
      <b-row>
        <b-col cols="2" v-for="(interval, index) in drivingStyleData.intervalData">
          <b-card no-body>
            <b-card-body>
              <b-container fluid="xl">
                <b-row align-v="center">
                  <b-col cols="12" align="center">
                    <div>
                      {{ $formatDate(new Date(interval.from)) }}
                    </div>
                    <div v-for="entityPeriodData in getPeriodData(interval)">
                      <div v-if="getEntityId(entityPeriodData) === entityId">
                        <p/>
                        <div v-for="entityData in getEntityData(entityPeriodData)">
                          <div v-if="entityData.driverId && entityData.driverId === 'UNKNOWN'">
                            {{ entityData.driverId }}
                          </div>
                          <div v-else>
                            <router-link :to="{ name: routeName, params: { type: routeType, entityId: entityData.assetId? entityData.assetId : entityData.driverId }}">
                              {{ entityData.assetName ? entityData.assetName : entityData.driverName }}
                            </router-link>
                          </div>
                          <div>
                            <div>
                              Drive distance
                            </div>
                            <div>
                              <h3>{{ $formatDistance(entityData.drivingStyleData.drivingDistance) }}</h3>
                            </div>
                            <p/>
                            <div v-if="entityData.scoreData">
                              <div>
                                Total score
                              </div>
                              <div>
                                <h3>{{ entityData.scoreData.totalScore }}</h3>
                              </div>
                            </div>
                            <p/>
                          </div>
                        </div>
                        <div>
                          <base-button size="sm" type="neutral" @click.native="handleViewTrips(new Date(interval.from))">Trips</base-button>
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-container>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import crudApi from "../../crud/crud-api";
import moment from "moment";

export default {
  name: "entity-interval",
  props: {
    type: {
      type: String,
      default: 'ASSET',
      description: "Types : ASSET, DRIVER"
    },
    entityId: {
      type: String,
      required: true,
      description: "Entity ID"
    },
    interval: {
      type: String,
      default: 'DAY',
      description: "DAY | WEEK | MONTH"
    }
  },
  created() {
    this.getReportData()
  },
  data: _ => ({
    drivingStyleData: undefined
  }),
  watch: {
    '$store.state.filter.update': function () {
      this.refreshData()
    },
  },
  computed: {
    loadDrivingStyleData() {
      this.getReportData()

      return true
    },
    routeName() {
      if (this.type === 'ASSET') {
        return 'driver-detail'
      } else {
        return 'asset-detail'
      }
    },
    routeType() {
      if (this.type === 'ASSET') {
        return 'DRIVER'
      } else {
        return 'ASSET'
      }
    },
  },
  methods: {
    refreshData() {
      console.log("EntityInterval - refreshData")

      this.getReportData()
    },
    getReportData() {
      let fromTime = undefined
      if (this.$store.state.filter.from) {
        fromTime = new Date(this.$store.state.filter.from)
      }

      let untilTime = undefined
      if (this.$store.state.filter.until) {
        untilTime = new Date(this.$store.state.filter.until)
      }

      if (this.type === 'ASSET') {
        crudApi.getAllVehicleDrivingStyleData(this.$store.state.auth.user.organisation_id, fromTime, untilTime, [ this.entityId ], undefined, false, this.interval, 100, 300, true).then(json => this.drivingStyleData = json.data ? json.data : json);
      } else {
        crudApi.getAllDriverDrivingStyleData(this.$store.state.auth.user.organisation_id, fromTime, untilTime, [ this.entityId ], undefined, false, this.interval, 100, 300, true).then(json => this.drivingStyleData = json.data ? json.data : json);
      }
    },
    getPeriodData(intervalData) {
      if (intervalData.assetPeriodData) {
        return intervalData.assetPeriodData
      } else {
        return intervalData.driverPeriodData
      }
    },
    getEntityData(periodData) {
      if (periodData.assetData) {
        return periodData.assetData
      } else {
        return periodData.driverData
      }
    },
    getEntityId(entityData) {
      if (entityData.assetId) {
        return entityData.assetId
      } else {
        return entityData.driverId
      }
    },
    handleViewTrips(fromDate) {
      this.$store.state.filter.trip_day = moment(fromDate).format().slice(0,10)

      this.$emit("showtrips")
    }
  }
}
</script>

<style scoped>

</style>
